export class Associado {
  private codigo:      number;
  private nome:        string;
  private cep:         string;
  private municipio:   number;
  private bairro:      string;
  private endereco:    string;
  private nro_ender:   number;
  private cnpj:        string;
  private tipo:        string;
  private ie:          string;
  private indic_ie:    string;
  private contato:     string;
  private data_abert:  string;
  private email:       string;
  private cidade:      string;
  private cpl_ender:   string;
  private proprietario:  string;
  private software:    string;
  private status:      string;
  private app:         string;
  private associado:   number;

  public toJSON() {
    return {
      codigo:     this.codigo,
      nome:       this.nome,
      cep:        this.cep,
      municipio:  this.municipio,
      bairro:     this.bairro,
      endereco:   this.endereco,
      nro_ender:  this.nro_ender,
      cnpj:       this.cnpj,
      tipo:       this.tipo,
      ie:         this.ie,
      indic_ie:   this.indic_ie,
      contato:    this.contato,
      data_abert: this.data_abert,
      email:      this.email,
      cidade:     this.cidade,
      cpl_ender:  this.cpl_ender,
      proprietario:    this.proprietario,
      software:   this.software,
      status:      this.status,
      app:     this.app,
      associado:  this.associado
    };
  }

  public toClass(associado) {
    this.codigo     = associado.codigo;
    this.nome       = associado.nome;
    this.cep        = associado.cep;
    this.municipio  = associado.municipio;
    this.bairro     = associado.bairro;
    this.endereco   = associado.endereco;
    this.nro_ender  = associado.nro_ender;
    this.cnpj       = associado.cnpj;
    this.tipo       = associado.tipo;
    this.ie         = associado.ie;
    this.indic_ie   = associado.indic_ie;
    this.contato    = associado.contato;
    this.data_abert = associado.data_abert;
    this.email      = associado.email;
    this.cidade     = associado.cidade;
    this.cpl_ender  = associado.cpl_ender;
    this.software = associado.software;
    this.proprietario      = associado.proprietario;
    this.status     = associado.status;
    this.app  = associado.app;
    this.associado  = associado.associado;
  }

}
